// import Loader from 'react-loaders';
// import 'loaders.css/src/animations/square-spin.scss';
// import React from 'react';
// // import loader_styles from './Loader.module.css';


// let loader = () => (
//     <Loader type="square-spin" />
// )


// export default loader;

import { DNA, Bars } from 'react-loader-spinner';

const Loader = () => (
    // <DNA
    //     visible={true}
    //     height="100vh"
    //     width="100%"
    //     ariaLabel="dna-loading"
    //     wrapperStyle={{margin: 'auto'}}
    //     wrapperClass="dna-wrapper"
    //     />
    <Bars
        height="100vh"
        width="50%"
        color="#D3EEFF"
        ariaLabel="bars-loading"
        wrapperStyle={{margin: 'auto 35% auto 45%'}}
        wrapperClass=""
        visible={true}
        />
);

export default Loader
